import { fetchConToken } from "../helpers/fetch";

const TrackingAbmService = {
  getTrackingEfectorDenunciaInternacion: (idTipoTracking, idCampoClave) => {
    return fetchConToken(
      `TrackingAbm/traerPorTipoClave/${idTipoTracking}/${idCampoClave}`
    );
  },
};

export default TrackingAbmService;